import React, { Component, PropTypes } from 'react';
import _ from 'lodash';
import { Icon, Tag, Alert, Spin } from 'antd';
import FeedItem from './FeedItem';
import { logAsync } from 'helpers/elogAsync';
import { fetchFeed } from '../actions';
import { showClippingSuccess, showClippingFull, showAuth } from 'modules/notification';

export default class FeedList extends Component {

  static propTypes = {
    model: PropTypes.object,
    query: PropTypes.object,
    dispatch: PropTypes.func,
  };

  static defaultProps = {
    model: {
      data: [],
      count: 0,
    },
  };

  componentDidMount() {
    const { model, dispatch, query } = this.props;
    if (!_.isEmpty(query.globalId)) {
      dispatch(fetchFeed({ query }));
    } else {
      if (_.isEmpty(model.data) && !_.isEmpty(query.subjectId)) {
        dispatch(fetchFeed({ query }));
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.query, nextProps.query)) {
      const { dispatch, query } = nextProps;
      dispatch(fetchFeed({ query }))
      const { register_email } = localStorage;
      logAsync({
        type: "sPOP-search",
        data: {
          query,
          user: register_email
        }
      })
    }
  }

  handleAppend = () => {
    const { dispatch, query } = this.props;
    dispatch(fetchFeed({
      query,
      isAppend: true
    }));
  };

  render() {
    const {
      model,
      query
    } = this.props;

    return (
      <div className="feed-list margin-bottom-md padding-left-md padding-right-md">
        {model.isLoading &&
          <div style={{ textAlign: 'center' }}>
            <Spin />
          </div>
        }
        {!model.isLoading && model.count === 0 &&
          <Alert
            message={t('commonNoData')}
            description={t('commonAlertDescription')}
            type="info"
            showIcon={true}
          />
          ||
          <div>
            <ul>
              {
                _.map(_.get(model, 'data'), (d, i) =>
                  <li key={i}>
                    <FeedItem data={d} />
                  </li>
                )
              }
              {_.get(model, 'data.length') < model.count &&
                <li className="append" onClick={this.handleAppend}>
                  {model.isLoading &&
                    <Icon type="loading" className="margin-right-md" />
                  }
                  <span>{t('commonClickLoadingMore')}</span>
                </li>
              }
            </ul>
          </div>
        }
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/feed/components/FeedList.js
 **/